import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteRouteParams } from '../../core/routeparams';

@Component({
  selector: 'app-redirect-entry',
  template: ``,
  standalone: false,
})
export class RedirectEntryComponent implements OnInit {
  private siteId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.siteId = (this.route.snapshot.params as SiteRouteParams).siteId;
    if (this.siteId) {
      this.router.navigateByUrl(`/site/${this.siteId}/overview`);
    } else {
      this.router.navigateByUrl('app-failure');
    }
  }
}
